<template>
    <div class="homes">
        <homeHead :isLoading="isLoading"></homeHead>
        <history message="节点购买"></history>
        <div class="sto">
            <div class="sto-swipe" style="margin-top: 10px;">
                <van-swipe
                    class="my-swipe"
                    :autoplay="3000"
                    indicator-color="white"
                >
                    <van-swipe-item>
                        <img
                            style="width: 100%; height: 190px"
                            src="./img/hk.jpg"
                        />
                    </van-swipe-item>
                    <van-swipe-item>
                        <img
                            style="width: 100%; height: 190px"
                            src="./img/photo1.jpg"
                        />
                    </van-swipe-item>
                    <van-swipe-item>
                        <img
                            style="width: 100%; height: 190px"
                            src="./img/photo2.jpg"
                        />
                    </van-swipe-item>
                </van-swipe>
            </div>
            <div class="sto-tjr-dz">
                <van-field
                   v-if="!userIsBind"
                    v-model="parentAddress"
                    center
                    clearable
                    placeholder="请输入推荐人地址"
                >
                    <template #button>
                        <van-button size="small" type="primary" @click="getUserBind()"
                            >绑定推荐人</van-button
                        >
                    </template>
                </van-field>
                <van-field
                   v-if="userIsBind"
                    v-model="parentAddress"
                    center
                    clearable
                    readonly
                    placeholder="请输入推荐人地址"
                >
                    <template #button>
                        <van-button size="small" type="primary"
                            >已绑定推荐人</van-button
                        >
                    </template>
                </van-field>
            </div>
            <div class="sto-tab">
                <div class="sto-tab-li">
                    <van-tabs v-model="active">
                        <van-tab title="节点额度">
                            <div>
                                <div class="sto-tab-box">
                                    <div
                                        class="sto-tab-box-li"
                                        @click="jumpTba(0)"
                                    >
                                        <img
                                            style="width: 180px; height: 110px; border-radius: 8px;"
                                            src="./img/6.jpg"
                                        />
                                        <!-- <img class="log-img" src="./img/logo.png"> -->
                                        <div class="jb-font">推荐奖20%</div>
                                        <!-- <div class="v-color"></div> -->
                                    </div>
                                    <div
                                        class="sto-tab-box-li"
                                        @click="jumpTba(1)"
                                    >
                                        <img
                                            style="width: 180px; height: 110px; border-radius: 8px"
                                            src="./img/5.jpg"
                                        />
                                        <!-- <img class="log-img" src="./img/logo.png"> -->
                                        <div class="jb-font">推荐奖15%</div>
                                        <!-- <div class="v-color"></div> -->
                                    </div>
                                </div>
                                <div class="sto-tab-box">
                                    <div
                                        class="sto-tab-box-li"
                                        @click="jumpTba(2)"
                                    >
                                        <img
                                            style="width: 180px; height: 110px; border-radius: 8px"
                                            src="./img/4.jpg"
                                        />
                                        <!-- <img class="log-img" src="./img/logo.png"> -->
                                        <div class="jb-font">推荐奖13%</div>
                                        <!-- <div class="v-color"></div> -->
                                    </div>
                                    <div
                                        class="sto-tab-box-li"
                                        @click="jumpTba(3)"
                                    >
                                        <img
                                            style="width: 180px; height: 110px; border-radius: 8px"
                                            src="./img/3.jpg"
                                        />
                                        <!-- <img class="log-img" src="./img/logo.png"> -->
                                        <div class="jb-font">推荐奖9%</div>
                                        <!-- <div class="v-color"></div> -->
                                    </div>
                                </div>
                                <div class="sto-tab-box">
                                    <div
                                        class="sto-tab-box-li"
                                        @click="jumpTba(4)"
                                    >
                                        <img
                                            style="width: 180px; height: 110px; border-radius: 8px"
                                            src="./img/2.jpg"
                                        />
                                        <!-- <img class="log-img" src="./img/logo.png"> -->
                                        <div class="jb-font">推荐奖7%</div>
                                        <!-- <div class="v-color"></div> -->
                                    </div>
                                    <div class="sto-tab-box-li">
                                        <div
                                        class="sto-tab-box-li"
                                        @click="jumpTba(5)"
                                    >
                                        <img
                                            style="width: 180px; height: 110px; border-radius: 8px"
                                            src="./img/1.jpg"
                                        />
                                        <!-- <img class="log-img" src="./img/logo.png"> -->
                                        <div class="jb-font">推荐奖5%</div>
                                        <!-- <div class="v-color"></div> -->
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </van-tab>
                        <!-- <van-tab title="邀请返利">
                            <div style="height: auto">
                                <div class="sto-fl">
                                    <div class="sto-fl-box">
                                        <div class="sto-fl-box-li color">
                                            你的总邀请奖励：
                                        </div>
                                        <div class="sto-fl-box-li color">
                                            {{ Number(this.income.recommend_dividends).toFixed(2) }} USDT
                                        </div>
                                    </div>
                                    <div
                                        class="sto-fl-box"
                                        style="margin: 12px 0"
                                    >
                                        <div class="sto-fl-box-li">
                                            <span
                                                class="color1"
                                                style="padding-right: 10px"
                                                >总邀请地址:</span
                                            >
                                            <span class="color2">0</span>
                                        </div>
                                        <div class="sto-fl-box-li">
                                            <span
                                                class="color1"
                                                style="padding-right: 10px"
                                                >今日邀请:</span
                                            >
                                            <span class="color2">0</span>
                                        </div>
                                    </div>
                                    <div class="sto-fl-box">
                                        <div class="sto-fl-box-li color">
                                            其中一代邀请:
                                        </div>
                                        <div
                                            class="sto-fl-box-li color"
                                            style="text-align: center"
                                        >
                                            <span
                                                class="color1"
                                                style="padding-right: 10px"
                                                >地址:</span
                                            >
                                            <span class="color2">0</span>
                                        </div>
                                        <div class="sto-fl-box-li color1">
                                            7%推荐奖励
                                        </div>
                                    </div>
                                    <div
                                        class="sto-fl-box"
                                        style="margin: 15px 0"
                                    >
                                        <div class="sto-fl-box-li color1">
                                            永恒V5：1 名
                                        </div>
                                        <div class="sto-fl-box-li color1">
                                            奖励：200USDT
                                        </div>
                                    </div>
                                    <div
                                        class="sto-fl-box"
                                        style="margin: 15px 0"
                                    >
                                        <div class="sto-fl-box-li color1">
                                            神祈V4：1 名
                                        </div>
                                        <div class="sto-fl-box-li color1">
                                            奖励：200USDT
                                        </div>
                                    </div>
                                    <div
                                        class="sto-fl-box"
                                        style="margin: 15px 0"
                                    >
                                        <div class="sto-fl-box-li color1">
                                            帝王V3：1 名
                                        </div>
                                        <div class="sto-fl-box-li color1">
                                            奖励：200USDT
                                        </div>
                                    </div>
                                    <div
                                        class="sto-fl-box"
                                        style="margin: 15px 0"
                                    >
                                        <div class="sto-fl-box-li color1">
                                            地主V2：1 名
                                        </div>
                                        <div class="sto-fl-box-li color1">
                                            奖励：200USDT
                                        </div>
                                    </div>
                                    <div
                                        class="sto-fl-box"
                                        style="margin: 15px 0"
                                    >
                                        <div class="sto-fl-box-li color1">
                                            矿工V1：3 名
                                        </div>
                                        <div class="sto-fl-box-li color1">
                                            奖励：200USDT
                                        </div>
                                    </div>

                                    <div
                                        class="sto-fl-box"
                                        style="margin: 25px 0"
                                    >
                                        <div class="sto-fl-box-li color">
                                            其中二代邀请:
                                        </div>
                                        <div
                                            class="sto-fl-box-li color"
                                            style="text-align: center"
                                        >
                                            <span
                                                class="color1"
                                                style="padding-right: 10px"
                                                >地址:</span
                                            >
                                            <span class="color2">0</span>
                                        </div>
                                        <div class="sto-fl-box-li color1">
                                            3%推荐奖励
                                        </div>
                                    </div>
                                    <div
                                        class="sto-fl-box"
                                        style="margin: 15px 0"
                                    >
                                        <div class="sto-fl-box-li color1">
                                            永恒V5：1 名
                                        </div>
                                        <div class="sto-fl-box-li color1">
                                            奖励：100USDT
                                        </div>
                                    </div>
                                    <div
                                        class="sto-fl-box"
                                        style="margin: 15px 0"
                                    >
                                        <div class="sto-fl-box-li color1">
                                            神祈V4：1 名
                                        </div>
                                        <div class="sto-fl-box-li color1">
                                            奖励：100USDT
                                        </div>
                                    </div>
                                    <div
                                        class="sto-fl-box"
                                        style="margin: 15px 0"
                                    >
                                        <div class="sto-fl-box-li color1">
                                            帝王V3：1 名
                                        </div>
                                        <div class="sto-fl-box-li color1">
                                            奖励：100USDT
                                        </div>
                                    </div>
                                    <div
                                        class="sto-fl-box"
                                        style="margin: 15px 0"
                                    >
                                        <div class="sto-fl-box-li color1">
                                            地主V2：1 名
                                        </div>
                                        <div class="sto-fl-box-li color1">
                                            奖励：100USDT
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </van-tab> -->
                        <van-tab :disabled="true" title="">内容 2</van-tab>
                        <van-tab :disabled="true" title="">内容 2</van-tab>
                        <van-tab :disabled="true" title="">内容 2</van-tab>
                    </van-tabs>
                </div>
                <!-- <div class="sto-tab-li">1</div> -->
            </div>
            <!-- <div class="sto-nft">
                <div class="sto-nft-li">
                    <div class="sto-nft-color">我的STO</div>
                </div>
                <div class="sto-nft-li color1" @click="$router.push('/history');">历史记录</div>
            </div>
            <div class="sto-tab-box">
                <div class="sto-tab-box-li" v-show="this.level == 0">
                    <img
                        style="width: 180px; height: 110px"
                        src="./img/sto-usdt.png"
                    />
                </div>
                <div class="sto-tab-box-li" v-show="this.level == 1">
                    <img
                        style="width: 180px; height: 110px"
                        src="./img/1.png"
                    />
                </div>
                <div class="sto-tab-box-li" v-show="this.level == 2">
                    <img
                        style="width: 180px; height: 110px"
                        src="./img/2.png"
                    />
                </div>
                <div class="sto-tab-box-li" v-show="this.level == 3">
                    <img
                        style="width: 180px; height: 110px"
                        src="./img/3.png"
                    />
                </div>
                <div class="sto-tab-box-li" v-show="this.level == 4">
                    <img
                        style="width: 180px; height: 110px"
                        src="./img/4.png"
                    />
                </div>
                <div class="sto-tab-box-li" v-show="this.level == 5">
                    <img
                        style="width: 180px; height: 110px"
                        src="./img/5.png"
                    />
                </div>
            </div> -->
            <div style="height: 60px;"></div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import homeHead from '../components/homeHead/homeHead'
import history from '../components/historyGo/historyGo.vue'
import { Toast } from 'vant';
export default {
    name: 'Index',
    // 组件
    components: {
        homeHead,
        history,
    },
    data() {
        return {
            active: 0,
            isLoading: false,
            sms:'',
            parentAddress: '',
            userIsBind:false,
            level: 0,
            income:'',
            jumpIndex: [
            {
                    u: 10000,
                    me: 100,
                    jd: 'V6',
                    qy: '20%',
                    jb: '团队收益的50%',
                    yqyd: '10%佣金',
                    yqed: '20%佣金',
                    syme: 10,
                    url: './img/1.png',
                    id: 6,
                    vip:"V6",
                },
                {
                    u: 5000,
                    me: 500,
                    jd: 'V5',
                    qy: '15%',
                    jb: '团队收益的40%',
                    yqyd: '10%佣金',
                    yqed: '15%佣金 ',
                    syme: 20,
                    url: './img/2.png',
                    id: 5,
                    vip:"V5",
                },
                {
                    u: 3000,
                    me: 1000,
                    jd: 'V4',
                    qy: '13%',
                    jb: '团队收益的30%',
                    yqyd: '10%佣金',
                    yqed: '5 %佣金',
                    syme: 50,
                    url: './img/4.png',
                    id: 4,
                    vip:"V4",
                },
                {
                    u: 1000,
                    me: 5000,
                    jd: 'V3',
                    qy: '9%',
                    jb: '团队收益的30%',
                    yqyd: '10%佣金',
                    yqed: '5 %佣金',
                    syme: 50,
                    url: './img/4.png',
                    id: 3,
                    vip:"V3",
                },
                {
                    u: 500,
                    me: 10000,
                    jd: 'V2',
                    qy: '7%',
                    jb: '团队收益的20%',
                    yqyd: '10%佣金',
                    yqed: '5%佣金',
                    syme: 100,
                    url: './img/5.png',
                    id: 2,
                    vip:"V2",
                },
                {
                    u: 100,
                    me: 50000,
                    jd: 'V1',
                    qy: '5%',
                    jb: '团队收益的10%',
                    yqyd: '10%佣金',
                    yqed: '5%佣金',
                    syme: 200,
                    url: './img/6.png',
                    id: 1,
                    vip:"V1",
                },
            ],
        }
    },
    computed: {},
    async created() {
        // await this.getUserInfo();
        // await this.getUserInfo();
        // await this.getUserProfitInfo();
    },
    async mounted(){
        let getUserInfo = JSON.parse(localStorage.getItem("getUserInfo"))
            if(getUserInfo){
                if(getUserInfo.parent==null){
                    return
                }
                this.parentAddress = getUserInfo.parent
                this.userIsBind = true
            }
    },

    methods: {
        async jumpTba(index) {
            let getUserInfo = JSON.parse(localStorage.getItem("getUserInfo"))
            if(getUserInfo){
                if(getUserInfo.parent==null){
                    return Toast.fail("请先绑定推荐人")
                }
                this.parentAddress = getUserInfo.parent
                this.userIsBind = true
                this.$router.push({
                path: '/stoByu1',
                query: this.jumpIndex[index],
                })
            }
        },
        // 绑定推荐人
        async getUserBind() {
            this.isLoading = true;
            if(this.parentAddress == ''){
                this.isLoading = false;
                return  Toast.fail("推薦人地址不能為空")
            }
            
            if(this.userIsBind){
                this.isLoading = false;
                return Toast.fail("已绑定推荐人，不可重复绑定！")
            }

            if(this.web3){
                let result = await this.basicWallet.getContract('fedtIdoContract');
                if(result){
                    if(result && this.web3.userAddress){
                        try{
                            let res = await result.methods.bindParent(this.parentAddress).send();
                            if(res){
                                this.isLoading = false;
                                this.userIsBind = true
                                let getUserInfo = JSON.parse(localStorage.getItem("getUserInfo"))
                                if(getUserInfo){
                                    getUserInfo.parent =  this.parentAddress
                                    localStorage.setItem('getUserInfo', JSON.stringify(getUserInfo)); 
                                }
                                return  Toast.fail("绑定成功")
                            }
                            this.isLoading = false;
                        }catch(error){
                            console.log(error)
                            this.isLoading = false;
                            return  Toast.fail("请输入正确的BSC地址")
                        }
                    }
                }
            }
            this.isLoading = false;
        },
    },
}
</script>
<style>
@import './style/sto.css';
</style>
